/**
 * Support page chat triggers.
 *
 * Any element carrying [data-support-chat] opens the Gorgias chat widget.
 *
 * IMPORTANT: before the widget bundle finishes loading, window.GorgiasChat is a
 * Proxy whose get trap THROWS on every property except init/resolve/constructor.
 * So feature-detecting with `typeof GorgiasChat.open === 'function'` raises an
 * error rather than returning false. The only safe entry point is init(), which
 * returns a promise resolving to the real chat API.
 *
 * If the widget is absent entirely (theme editor, app embed off) we fall back to
 * the element's data-support-chat-fallback URL, normally a mailto, so a control
 * is never a dead end.
 *
 * Delegated at the document level and guarded so multiple sections can load this
 * file without binding twice.
 */
(function () {
  if (window.__madsonSupportChatBound) return;
  window.__madsonSupportChatBound = true;

  function fallbackTo(url) {
    if (url) window.location.href = url;
  }

  function openChat(fallback) {
    var api = window.GorgiasChat;

    if (!api) {
      fallbackTo(fallback);
      return;
    }

    try {
      // init() is the only property safe to touch pre-initialization.
      api.init()
        .then(function (chat) {
          var target = chat && typeof chat.open === 'function' ? chat : window.GorgiasChat;
          target.open();
        })
        .catch(function () {
          fallbackTo(fallback);
        });
    } catch (error) {
      fallbackTo(fallback);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-support-chat]');
    if (!trigger) return;

    event.preventDefault();
    openChat(trigger.getAttribute('data-support-chat-fallback'));
  });
})();
